var cannotLoadAjax = "Can not process your request";

document.addEventListener('DOMContentLoaded', function() {  

  // Initialize InputMask
  $("#Phone").inputmask("999-999-9999");
  var captchaKey = $("#GoogleCaptchaKey").val();
  $("div.g-recaptcha").attr("data-sitekey", captchaKey);

  $("div#step1 #btnUserRequest").on("click", function(){
    validateEmail();
  });

  $("div#step2 #btnUserRequest").on("click", function(){
    oldUserRequest();
  });

  $("div#step3 #btnUserRequest").on("click", function(){
    newUserRequest();
  });

  $("#requestType0").on("click", function(){
    setRequestType(0);
  });

  $("#requestType1").on("click", function(){
    setRequestType(1);
  });

  $("div#deletingModal button.btn-dark").on("click", function(){
    deleteAccounts();
  });
  
});

function setRequestType(requestType) {
   $("#RequestType").val(requestType);  

   if (requestType == 0) {
     $("#requestType0").removeClass("inv-btn-stroke");
     $("#requestType0").addClass("inv-btn-solid-red");

     $("#requestType1").addClass("inv-btn-stroke");
     $("#requestType1").removeClass("inv-btn-solid-red");
   } else {
     $("#requestType0").addClass("inv-btn-stroke");
     $("#requestType0").removeClass("inv-btn-solid-red");

     $("#requestType1").removeClass("inv-btn-stroke");
     $("#requestType1").addClass("inv-btn-solid-red");                
   }
 }

function setCurrentStep(step){
  switch (step)
  {
    case 1:
      resetCaptchar(0);
      $("#step1").show();
      $("#step2").hide();
      $("#step3").hide();
      break;
    case 2:
      resetCaptchar(1);
      $("#step1").hide();
      $("#step2").show();
      $("#step3").hide();
      break;
    case 3:
      resetCaptchar(2);
      $("#step1").hide();
      $("#step2").hide();
      $("#step3").show();
      break;
  }
}

function validateEmail ()
{  
  $("#errorMessage").hide();
  var isValid = validateUserRequestForm('step1');
  
  if(isValid){ 
	 $('#ModalContentAjax').modal("show");
     var email = $("div#step1 input[id=EmailAddress]").val();
        xhr = $.ajax({
            type: "POST",           
            url: "/apps/innova-api/supports/check-existed-email",
            data: "Email="+ email,//$("#step1").serialize(),
            error: function () {
              $('#ModalContentAjax').modal("hide");
              resetCaptcharAll();
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success){                 
                  if(result.existedUser ){
                    $("#UserEmail").val(email);
					setCurrentStep(2);
                  }else{
                     $("#Email").val(email);
                  	setCurrentStep(3);
                  }
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
              	resetCaptcharAll();
            }
        });   
  }
  
  return false;
}

function oldUserRequest(){
	 $("#errorMessage").hide();
  var isValid = validateUserRequestForm('step2');
  
  if(isValid){ 
	 $('#ModalContentAjax').modal("show");
     var requestType = $("#RequestType").val();
     var email = $("div#step2 input[id=UserEmail]").val();
     var psw = $("div#step2 input[id=Password]").val();
        xhr = $.ajax({
            type: "POST",           
            url: "/apps/innova-api/supports/old-user-request-info",
            data: "Email="+ email + "&Password=" + psw + "&RequestType=" + requestType,//$("#step2").serialize(),
            error: function () {
              $('#ModalContentAjax').modal("hide");
              resetCaptcharAll();
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success){                 
                  if(result.existedUser ){
                    var requestType = $("#RequestType").val();
                    if(requestType == "0"){
                    	window.location = "/pages/consumermessage";
                    }else if(requestType == "1"){
                      	$("#totalUser").html(result.totalUser);
                    	$('#deletingModal').modal("show");
                    }
                  }else{
                    $("#errorMessage").html(result.message.description);
                    $("#errorMessage").show();
                  }
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
              	resetCaptcharAll();
            }
        });   
  }
  
  return false;
}

function deleteAccounts(){
  $('#ModalContentAjax').modal("show");
  var email = $("div#step2 input[id=UserEmail]").val();
  var psw = $("div#step2 input[id=Password]").val();
  xhr = $.ajax({
    type: "POST",   
    url: "/apps/innova-api/supports/delete-requested-users",
    data: "Email="+ email + "&Password=" + psw,
    error: function () {
      $('#ModalContentAjax').modal("hide");
      resetCaptcharAll();
      alert(cannotLoadAjax);
    },
    success: function (result) {
      $('#ModalContentAjax').modal("hide");
      $('#deletingModal').modal("hide");
      if(result.message.success && result.existedUser){
            window.location = "/pages/consumermessage"; 
      }else{
        $("#errorMessage").html(result.message.description);
        $("#errorMessage").show();
      }
      resetCaptcharAll();
    }
  });  
}

function newUserRequest(){
  $("#errorMessage").hide();
  var isValid = validateUserRequestForm('step3');
  
  if(isValid){ 
	 $('#ModalContentAjax').modal("show");     
        xhr = $.ajax({
            type: "POST",           
            url: "/apps/innova-api/supports/new-user-request-info",
            data: $("#frmUserRequest").serialize(),
            error: function () {
              $('#ModalContentAjax').modal("hide");
              resetCaptcharAll();
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success && result.existedUser){
                    window.location = "/pages/consumermessage"; 
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
              	resetCaptcharAll();
            }
        });   
  }
  
  return false;
}

function validateUserRequestForm(contentId){
  var isValid = checkRequiredFields(contentId);
  var capcharVal = $("#captchaText").val();
  var errorMsg = "";
  $("#errorMessage").hide();
  
  if(!isValid){
  	errorMsg = "The field highlighted in red is required and must be filled out.";
  }
  if(capcharVal != 1 ){
    if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Invalid security code.";
  }
  if(!IsEmailFields(contentId)){
  	if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Email format is invalid.";
  }
  
  if(contentId == "step3"){
    if(!IsPhoneNumber(contentId)){
      if(errorMsg != "")
        errorMsg += "<br/>";

      errorMsg += "Phone Number is invalid.";
    }
  }
  
  if(errorMsg != ""){
  	$("#errorMessage").html(errorMsg);
    $("#errorMessage").show();
  }
  
  return (errorMsg == "");
}

  var actCallback = function (response) {
  	
      $("#captchaText").val("1");
      $('#re-captcha').remove();
    
  };

  var expCallback = function() {
     $("#captchaText").val("0");
     resetCaptcharAll();
     setTimeout(function(){
       resetCaptcharAll();
     }, 120000);
  };
 /*
  var onloadCallback = function () {
    var captchaKey = $("#GoogleCaptchaKey").val();
    var widget = grecaptcha.render(document.getElementById("re-captcha"), {
      'sitekey' : captchaKey, // Sitekey, Retrieving from reCaptcha
      'theme': "light",
      'callback' : actCallback,
      'expired-callback': expCallback,
    });
  }
  */
  var onloadCallback = function() {
    var captchaKey = $("#GoogleCaptchaKey").val();
    var recaptchas = document.querySelectorAll('div[class=g-recaptcha]');

    for( i = 0; i < recaptchas.length; i++) {
      grecaptcha.render(document.getElementById('re-captchaStep' + i), {
        'sitekey' : captchaKey,
        'callback' : actCallback,
        'expired-callback': expCallback,
      });
    }
  }

  function resetCaptchar(index){
  	 $("#captchaText").val("0");
     $('#re-captcha' + index).show();             
	 grecaptcha.reset(index);
  }

  function resetCaptcharAll(){
 	var recaptchas = document.querySelectorAll('div[class=g-recaptcha]');
    for( i = 0; i < recaptchas.length; i++) {
      grecaptcha.reset(i);
    }
  }
